module.exports = __webpack_public_path__ + "img/0120.655e1835.jpg";